import { makeAutoObservable } from 'mobx'

/**
 * Store that manages shares and manage navigation component state, mainly for components that could be outside a
 * header component in this project
 */
class NavigationMenuStore {
    public isNavVisible: boolean = false

    public constructor() {
        makeAutoObservable(this)
    }

    public showNavMenu = () => {
        this.isNavVisible = true
    }

    public hideNavMenu = () => {
        this.isNavVisible = false
    }

    public toggleNavMenu = () => {
        this.isNavVisible = !this.isNavVisible
    }
}

export const navigationMenuStore = new NavigationMenuStore()
